import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { useSelector } from '../../../../../redux/store';
import { RelatedInvoiceType } from '../../../../../utils/globalEnums';
import AlertBanner from '../../../../../reusable-components/alert-banner/AlertBanner';

export const RelatedInvoiceAlert = ({ setHighlightedRelatedInvoices }) => {
  const { id } = useParams();
  const {
    data: {
      relatedInvoices: { invoiceId: relatedInvoiceId, related = [] },
    },
  } = useSelector((state) => state.invoicing);

  if (related.length === 0 || relatedInvoiceId !== Number(id)) return null;

  const potentialDuplicate = related.filter(
    (r) => r.type === RelatedInvoiceType.PotentialDuplicate || r.type === RelatedInvoiceType.PotentialSpaceDuplicate
  );
  return (
    <>
      {related.filter(
        (r) => r.type === RelatedInvoiceType.PotentialDuplicate || r.type === RelatedInvoiceType.PotentialSpaceDuplicate
      )?.length > 0 && (
        <Box sx={{ width: '92%', mx: 'auto', pb: 2 }}>
          <AlertBanner
            title={'Potential Duplicate Found'}
            subtitle="Review matches in the Related Invoices tab before submitting"
            onClick={() => setHighlightedRelatedInvoices(potentialDuplicate.map((r) => r.id))}
          />{' '}
        </Box>
      )}
    </>
  );
};
